/*--------------------------------------------------------*\
    Validate Monogram
\*--------------------------------------------------------*/
var validateMonogram = function(el){


    var $monogramStep = $(el).closest('[js-step-monogram]');

    if (!$monogramStep.length) {
        return true;
    }




    var $monogramTextInput = $monogramStep.find('[js-monogram-text-input]');
    var $monogramSaveBtn = $monogramStep.find('[js-monogram-save-btn]');

    var monogramStepVisible = $monogramStep.is(':visible');
    var monogramChecked = $monogramStep.find('[js-include-monogram-input]').is(':checked');
    var monogramColorUnchecked = !$monogramStep.find('.customize__input[name="Monogram"]').is(':checked');
    var noMonogramTextValue =  ! $monogramTextInput.find('input[type="text"]').val();


    var noMonogramColorSelection = !! parseInt( $($monogramTextInput).attr('colorselection') );



    console.warn( $($monogramTextInput).attr('colorselection') );


    console.log({
       'monogramStepVisible': monogramStepVisible,
       'monogramChecked': monogramChecked,
       'noMonogramTextValue': noMonogramTextValue,
       'monogramColorUnchecked': monogramColorUnchecked,
    });

    if (monogramStepVisible && monogramChecked) {

        if (noMonogramTextValue || monogramColorUnchecked) {

           //if (noMonogramColorSelection) {
                alertify.alert('Please provide your monogram text.');
           //} else {
           //    alertify.alert('Please provide your monogram text and color.');
           //}

            return false;
        } else {
            return true;
        }

    }



    return true;

};









/*--------------------------------------------------------*\
    Validate Required Step
\*--------------------------------------------------------*/
var validateRequiredStep = function(el){


    // proceed if clicking on current step
    if ($(el).hasClass('is-current')) {
        return true;
    }

    // proceed if clicking on finished step
    if ($(el).hasClass('is-finished')) {
        return true;
    }



    var stepWrapper = $(el).closest('.js-product-customize').find('.js-step.is-current');

    if (stepWrapper) {
        var radios = $(stepWrapper).find('input[type="radio"]');
    } else {
        var radios = $('.js-step.is-current').find('input[type="radio"]');
    }

    var passing = false;
    $(radios).each(function(index, el) {

        $(el).is(':checked') ? passing = true : false;

    });


    if (!radios.length) {
        passing = true;
    }

    if (!passing) {
        alertify.alert('You need to choose customization option.');
    }

    return passing;



};








/*--------------------------------------------------------*\
    Validate Step Trigger Click
    - does the job that validateRequiredStep missed
\*--------------------------------------------------------*/
var validateStepTriggerClick = function(el, event){

    //console.warn('click!', el, event);

    // proceed if clicking on current step
    if ($(el).hasClass('is-current')) {
        return true;
    }


    // proceed if clicking on finished step
    if ($(el).hasClass('is-finished')) {
        return true;
    }


    // get radios from previous step container
    var stepId = $(el).attr('data-step');
    var stepContainer = $('.js-step[data-step="'+stepId+'"]');
    var previousStepContainer = stepContainer.prev('.js-step');
    var radios = previousStepContainer.find('input[type="radio"]');


    // check them
    var passing = false;
    $(radios).each(function(index, radio) {
        if ($(radio).is(':checked')) {
            passing = true;
        }
    });


    // show alert
    if (!passing) {
        alertify.alert('Before moving forward you need to choose previous customization option.');
    }

    return passing;

};









module.exports = {
    validateMonogram: validateMonogram,
    validateRequiredStep: validateRequiredStep,
    validateStepTriggerClick: validateStepTriggerClick,
};



// WEBPACK FOOTER //
// ./js-source/integration/cust-utils.js